// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { getUser, setReturnURL} from '../../../utils/commonfunction';
// import { ROLE } from "../../../utils/Constants";

// const PrivateRoute = ({ component: Component }) => {
    
//     const userData = getUser(ROLE.SUPER_ADMIN);
//     return (
//         <>
//             {(function(){
//                 if(Object.keys(userData).length && userData.token){
//                     return <Component/>
//                 }else{
//                     setReturnURL(ROLE.SUPER_ADMIN);
//                     return <Navigate to="/admin/login" />;
//                 }
//             })()}
//         </>
//     )
// }

// export default PrivateRoute;


import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getUser, setReturnURL } from '../../../utils/commonfunction';
import { ROLE } from "../../../utils/Constants";
import NoPermission from '../common/noPermissions';

// const PrivateRoute = ({ component: Component, requiredPermission = null }) => {
//     const userData = getUser(ROLE.SUPER_ADMIN);
//     const location = useLocation();

//     const isSuperAdmin = userData?.role === "super_admin";
//     const isStaff = userData?.role === "staff";

//     const storedPermissions = userData?.staff_permissions?.length
//         ? userData.staff_permissions
//         : JSON.parse(localStorage.getItem("staff_permissions")) || [];

//     const permissionData = storedPermissions.map(p => p.module_slug);

//     const hasPermission = (slug) => {
//         if (isSuperAdmin) return true;
//         if (isStaff) return permissionData.includes(slug);
//         return false;
//     };

//     if (userData && userData.token) {
//         if (!requiredPermission || hasPermission(requiredPermission)) {
//             return <Component />;
//         } else {
//             return <NoPermission state={{ from: location }} replace />;
//         }
//     } else {
//         setReturnURL(ROLE.SUPER_ADMIN);
//         return <Navigate to="/admin/login" />;
//     }
// };

const PrivateRoute = ({ component: Component, requiredPermission = null }) => {
    const userData = getUser(ROLE.SUPER_ADMIN);
    const location = useLocation();

    const isSuperAdmin = userData?.role === "super_admin";
    const isStaff = userData?.role === "staff";

    // Static permissions for staff only
    const staffStaticPermissions = [
        "appointment_management",
        "patient_management",
        "management-section"
    ];

    const hasPermission = (slug) => {
        if (isSuperAdmin) return true;
        if (isStaff) return staffStaticPermissions.includes(slug);
        return false;
    };

    if (userData && userData.token) {
        if (!requiredPermission || hasPermission(requiredPermission)) {
            return <Component />;
        } else {
            return <NoPermission state={{ from: location }} replace />;
        }
    } else {
        setReturnURL(ROLE.SUPER_ADMIN);
        return <Navigate to="/admin/login" />;
    }
};

export default PrivateRoute;

